import digitalPrinting from "./templates/digital-printing";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <h3>Круглые часы с пластиковой рамкой. Диаметр 29 см</h3>
        <p>Часы с логотипом - это отличное решение для вашего офиса, а так же прекрасный фотосувенир. Ваша фантазия и наша печать позволят вам получить отличные часы с фотографиями или рисунком.</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
